function Libya({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1528)">
  <path d="M1.58763 9.04366C0.5705 11.1472 0 13.507 0 16.0002C0 18.4933 0.5705 20.8532 1.58763 22.9567L16 24.348L30.4124 22.9567C31.4295 20.8532 32 18.4933 32 16.0002C32 13.507 31.4295 11.1472 30.4124 9.04366L16 7.65234L1.58763 9.04366Z" fill="black"/>
  <path d="M1.58813 22.9561C4.17601 28.308 9.65657 31.9996 15.9999 31.9996C22.3433 31.9996 27.8239 28.308 30.4117 22.9561H1.58813Z" fill="#496E2D"/>
  <path d="M1.58813 9.0435H30.4117C27.8239 3.69156 22.3433 0 15.9999 0C9.65657 0 4.17601 3.69156 1.58813 9.0435Z" fill="#D80027"/>
  <path d="M19.7241 13.0742L21.0369 14.8833L23.1629 14.1939L21.8481 16.0014L23.1607 17.8104L21.0354 17.1184L19.7206 18.9259L19.7219 16.6908L17.5966 15.9988L19.7227 15.3095L19.7241 13.0742Z" fill="#F0F0F0"/>
  <path d="M16.1413 20.5216C13.6441 20.5216 11.6196 18.4971 11.6196 15.9998C11.6196 13.5026 13.6441 11.4781 16.1413 11.4781C16.92 11.4781 17.6527 11.6749 18.2923 12.0216C17.2888 11.0403 15.9165 10.4346 14.4022 10.4346C11.3286 10.4346 8.83704 12.9262 8.83704 15.9998C8.83704 19.0733 11.3287 21.5649 14.4022 21.5649C15.9166 21.5649 17.2888 20.9593 18.2923 19.9779C17.6526 20.3247 16.92 20.5216 16.1413 20.5216Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Libya;
